import React from "react";

// Renders nothing when there is no error, so call sites can drop the
// `{errors.x && ...}` guard they all repeated. The class string below
// appeared 43 times.
const FieldError: React.FC<{ children?: string | null }> = ({ children }) =>
  children ? (
    <p role="alert" className="mt-1 text-sm text-red-600">
      {children}
    </p>
  ) : null;

export default FieldError;
